
const infoSitio = {
  netlifySiteId: process.env.GATSBY_NETLIFY_SITE_ID,
}

export default infoSitio
